/** Repair JOB receipt (customer device check-in) — same header & footer as POS invoice */
import { getCurrentUserName } from './auth';
import { resolveBranchForPrint } from './branchPrint';

const esc = (v) => String(v ?? '-').replace(/</g, '&lt;');

export const printRepairGrn = (repair, branch = null) => {
  const receivedBy = getCurrentUserName();
  const branchInfo = resolveBranchForPrint({
    branchName: branch?.name || repair?.branch_name || repair?.branch?.name,
    branchCode: branch?.branch_code || repair?.branch_code || repair?.branch?.branch_code,
    branch: branch || repair?.branch
  });
  const win = window.open('', '_blank', 'width=580,height=820,scrollbars=yes,resizable=yes');
  if (!win) {
    alert('Please allow pop-ups to print the JOB receipt');
    return;
  }

  const baseUrl = window.location.origin;
  const logoUrl = `${baseUrl}/LOGOFile.png`;
  const grn = repair.grn_number || repair.service_number || `JOB-${repair.id}`;
  const receivedDate = repair.received_date || repair.created_at || new Date();
  const dateStr = new Date(receivedDate).toLocaleDateString();
  const timeStr = new Date(receivedDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  win.document.write(`
<!DOCTYPE html>
<html>
<head>
  <title>Repair JOB ${grn}</title>
  <base href="${baseUrl}/">
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&family=Roboto+Mono:wght@400;500&display=swap');
    * { margin: 0; padding: 0; box-sizing: border-box; }
    @media print {
      @page { size: A5 portrait; margin: 8mm; }
      html, body { width: 148mm; height: 210mm; margin: 0; padding: 0; }
      .no-print { display: none !important; }
      .receipt-container { border: none; border-radius: 0; padding: 0; }
    }
    body {
      font-family: 'Poppins', sans-serif;
      font-size: 9.5px;
      padding: 6px;
      width: 148mm;
      max-width: 148mm;
      min-height: 210mm;
      margin: 0 auto;
      background: white;
      color: #333;
    }
    .receipt-container { border: 1px solid #ddd; padding: 8px 10px; border-radius: 6px; }
    .header {
      display: flex; align-items: center; justify-content: space-between;
      margin-bottom: 8px; padding-bottom: 6px; border-bottom: 2px solid #1976d2;
    }
    .company-logo { height: 65px; width: auto; max-width: 140px; object-fit: contain; }
    .company-info { flex: 1; text-align: right; }
    .company-name { font-size: 11px; font-weight: 700; color: #1976d2; }
    .store-info { font-size: 8px; color: #666; margin-top: 2px; line-height: 1.25; }
    .doc-header {
      display: flex; justify-content: space-between; align-items: flex-start;
      margin-bottom: 8px; padding: 6px 8px; background: #e3f2fd; border-radius: 4px;
      border: 1px solid #1976d2;
    }
    .doc-title { font-size: 12px; font-weight: 700; color: #1976d2; line-height: 1.2; }
    .grn-number { font-family: 'Roboto Mono', monospace; font-size: 13px; font-weight: 700; color: #d32f2f; }
    .info-block {
      margin-bottom: 6px; padding: 6px 8px; background: #f9f9f9;
      border-left: 3px solid #1976d2; border-radius: 0 3px 3px 0;
    }
    .info-row { display: flex; margin-bottom: 3px; line-height: 1.3; }
    .info-label { width: 95px; font-weight: 600; color: #555; flex-shrink: 0; font-size: 9px; }
    .info-value { flex: 1; font-size: 9.5px; }
    .section-title {
      font-size: 10px; font-weight: 700; color: #1976d2;
      margin: 6px 0 4px; padding-bottom: 2px; border-bottom: 1px solid #ddd;
    }
    .issue-box {
      padding: 6px 8px; background: #fff8e1; border: 1px solid #ffc107;
      border-radius: 3px; min-height: 36px; margin-top: 2px; font-size: 9.5px; line-height: 1.35;
    }
    .footer { margin-top: 10px; text-align: center; }
    .signature-section { display: flex; justify-content: space-between; margin: 12px 0 8px; font-size: 8.5px; }
    .terms { font-size: 7.5px; color: #666; text-align: left; margin: 8px 0; padding: 6px; background: #f5f5f5; border-radius: 3px; line-height: 1.35; }
    .print-button {
      position: fixed; bottom: 20px; right: 20px; background: #1976d2; color: white;
      border: none; padding: 10px 20px; border-radius: 4px; font-size: 13px; cursor: pointer; font-weight: 600;
    }
    .barcode-text { font-family: 'Roboto Mono', monospace; letter-spacing: 2px; font-size: 11px; text-align: center; margin-top: 6px; }
    .doc-subtitle { font-size: 8px; color: #666; margin-top: 2px; }
    .grn-label { font-size: 8px; color: #666; }
    .footer p { line-height: 1.3; margin: 2px 0; }
  </style>
</head>
<body>
  <div class="receipt-container">
    <div class="header">
      <div><img src="${logoUrl}" alt="Logo" class="company-logo" onerror="this.style.display='none'"></div>
      <div class="company-info">
        <div class="company-name">IT Professionals Since 1997</div>
        <div class="store-info">
          1118, Pannipitiya Road, Wickramasinghepura, Thalawathugoda<br>
          Tel: 011 27 96 579 | 94 77 987 1130<br>
          Email: info@sunsystems.lk | Web: sunsystems.lk
        </div>
      </div>
    </div>

    <div class="doc-header">
      <div>
        <div class="doc-title">REPAIR JOB RECEIPT</div>
        <div class="doc-subtitle">Device received for repair — customer copy</div>
      </div>
      <div style="text-align:right;">
        <div class="grn-label">JOB Number</div>
        <div class="grn-number">${esc(grn)}</div>
      </div>
    </div>

    <div class="info-block">
      <div class="info-row"><span class="info-label">Date Received:</span><span class="info-value">${dateStr} at ${timeStr}</span></div>
      <div class="info-row"><span class="info-label">Service Ref:</span><span class="info-value">${esc(repair.service_number || repair.repair_number || '-')}</span></div>
      <div class="info-row"><span class="info-label">Branch:</span><span class="info-value"><strong>${esc(branchInfo.label)}</strong></span></div>
      ${branchInfo.code ? `<div class="info-row"><span class="info-label">Branch Code:</span><span class="info-value">${esc(branchInfo.code)}</span></div>` : ''}
    </div>

    <div class="section-title">Customer Information</div>
    <div class="info-block">
      <div class="info-row"><span class="info-label">Customer Name:</span><span class="info-value"><strong>${esc(repair.customer_name)}</strong></span></div>
      <div class="info-row"><span class="info-label">Telephone:</span><span class="info-value">${esc(repair.customer_phone)}</span></div>
      ${repair.customer_email ? `<div class="info-row"><span class="info-label">Email:</span><span class="info-value">${esc(repair.customer_email)}</span></div>` : ''}
    </div>

    <div class="section-title">Device Information</div>
    <div class="info-block">
      <div class="info-row"><span class="info-label">Device Type:</span><span class="info-value">${esc(repair.device_type)}</span></div>
      <div class="info-row"><span class="info-label">Brand:</span><span class="info-value">${esc(repair.device_brand)}</span></div>
      <div class="info-row"><span class="info-label">Model:</span><span class="info-value">${esc(repair.device_model)}</span></div>
      ${repair.device_serial ? `<div class="info-row"><span class="info-label">Serial No:</span><span class="info-value">${esc(repair.device_serial)}</span></div>` : ''}
      ${repair.device_imei ? `<div class="info-row"><span class="info-label">IMEI:</span><span class="info-value">${esc(repair.device_imei)}</span></div>` : ''}
    </div>

    <div class="section-title">Accessories Received</div>
    <div class="info-block"><div class="info-value">${esc(repair.accessories_received || 'None')}</div></div>

    <div class="section-title">Physical Condition</div>
    <div class="info-block"><div class="info-value">${esc(repair.physical_condition || 'Not recorded')}</div></div>

    <div class="section-title">Reported Issue</div>
    <div class="issue-box">${esc(repair.device_issue || 'Not specified')}</div>

    <div class="barcode-text">* ${esc(grn)} *</div>

    <div class="terms">
      <strong>Terms & Conditions:</strong><br>
      • Please keep this JOB receipt for collection of your device.<br>
      • Quote this JOB number (${esc(grn)}) when inquiring about your repair.<br>
      • Sun Systems International is not responsible for data loss during repair.<br>
      • Unclaimed devices after 90 days may be disposed of as per company policy.
    </div>

    <div class="footer">
      <div class="signature-section">
        <div style="text-align:center;width:45%;">..............................<br><strong>Received By</strong><br>${esc(receivedBy)}</div>
        <div style="text-align:center;width:45%;">..............................<br><strong>Customer Signature</strong></div>
      </div>
      <hr style="border:none;border-top:2px solid #1976d2;margin:6px 0;">
      <p style="font-size:10px;font-weight:600;color:#1976d2;">Thank you for choosing Sun Systems International – We value your trust!</p>
      <p style="font-size:8px;font-weight:700;">Your End-to-End IT Hardware Partner</p>
      <p style="font-size:8px;">• Retail • Repair • Service • Rental • Web • Corporate IT Support</p>
      <p style="font-size:8px;font-weight:600;">Affordable. Reliable. Guaranteed.</p>
      <hr style="border:none;border-top:1px dashed #ddd;margin:4px 0;">
      <p style="font-size:8px;">ERP System by Sun Systems International | 94 77 987 1130</p>
    </div>
  </div>
  <button class="print-button no-print" onclick="window.print();">🖨️ Print A5 JOB</button>
</body>
</html>
  `);

  win.document.close();
  win.focus();
};

export default printRepairGrn;
